import { getFirstChannelForHouseId } from '../../channelList/channelListSelectors';
import { getSelectedChannelId } from '../../channels/channelsSelectors';
import changeSelectedChannelId from '../../channels/channelsThunks/changeSelectedChannelId';
import { resetNewChannelOptions } from '../../newChannelOptions/newChannelOptionsSlice';
import { selectedHouseIdChanged } from '../housesSlice';

const changeSelectedHouseId =
  ({ selectedHouseId }) =>
  async (dispatch, getState) => {
    const selectedChannelId = getSelectedChannelId(getState());
    const nextChannel = getFirstChannelForHouseId(selectedHouseId)(getState());

    if (nextChannel && nextChannel !== selectedChannelId) {
      dispatch(changeSelectedChannelId({ selectedChannelId: nextChannel }));
    }

    dispatch(selectedHouseIdChanged({ selectedHouseId }));
    dispatch(resetNewChannelOptions());
  };

export default changeSelectedHouseId;
